import GpsTipoColocacion from "./GpsTipoColocacionForm";
export default GpsTipoColocacion;
